import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // SUPER_ADMIN bypasses any specific requiredRole check -- matches the backend's own
  // authorization convention (every authorize(...) list that includes PLATFORM_ADMIN across all
  // 3 services also explicitly includes SUPER_ADMIN; schema.prisma's RoleName describes it as
  // having "access to all features"). Without this, a Super Admin could authenticate and the
  // backend would serve them Platform Admin data, but the frontend blocked them from ever
  // reaching the page. Found via prod-role-verification.spec.ts against live production.
  const isSuperAdmin = user?.roles?.includes('SUPER_ADMIN');
  if (requiredRole && !isSuperAdmin && !user?.roles?.includes(requiredRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
